import fetchGraphQl from "./fetchGraphQl";
import { useQuery } from "react-query";

export const GetFarmUrl = async (userId: string) => {
  const { data } = await fetchGraphQl(
    `
      query queryFarmUrl {
        settings(
          where: {name: {_eq: "farm_url"}}
        ) {
          name
          value
          id
        }
      }
    `,
    "queryFarmUrl",
    userId
  );

  return data.settings[0].value;
};

export const GetFarmKey = async (userId: string) => {
  const { data } = await fetchGraphQl(
    `
      query queryFarmKey {
        settings(
          where: {name: {_eq: "farm_token"}}
        ) {
          name
          value
          id
        }
      }
    `,
    "queryFarmKey",
    userId
  );

  return data.settings[0].value;
};

export const GetFarmDetails = async (userId: string) => {
  const { data } = await fetchGraphQl(
    `
      query queryFarmDetails {
        settings(
          where: {farm_name: {_eq: "${sessionStorage.getItem("farm_name")}"}}
        ) {
          farm_url
          farm_token
        }
      }
    `,
    "queryFarmDetails",
    userId
  );

  return data.settings[0];
};

export const GetDecisions = (farmUrl: string, farmKey: string) => {
  return fetch(`${farmUrl}/decisions.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "getDecisions",
    },
  }).then((result) => result.json());
};

export const GetCurrentDecision = (farmUrl: string, farmKey: string) => {
  return fetch(`${farmUrl}/action.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "getCurrentDecision",
    },
  }).then((result) => result.json());
};

export const ApplyDecision = (farmUrl: string, farmKey: string, id: string) => {
  const body = new FormData();
  body.set("decision", id);

  return fetch(`${farmUrl}/action.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "applyDecision",
    },
    body,
  });
};

export const AddDecision = (farmUrl: string, farmKey: string, name: string) => {
  const body = new FormData();
  body.set("name", name);

  return fetch(`${farmUrl}/decisions.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "insertDecision",
    },
    body,
  }).then((result) => result.json());
};

export const UpdateDecision = (farmUrl: string, farmKey: string, id: string, name: string) => {
  const body = new FormData();
  body.set("id", id);
  body.set("name", name);

  return fetch(`${farmUrl}/decisions.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "renameDecision",
    },
    body,
  }).then((result) => result.json());
};

export const DeleteDecision = (farmUrl: string, farmKey: string, id: string) => {
  const body = new FormData();
  body.set("id", id);

  return fetch(`${farmUrl}/decisions.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "deleteDecision",
    },
    body,
  }).then((result) => result.json());
};

export const GetMiners = (farmUrl: string, farmKey: string) => {
  return fetch(`${farmUrl}/profiles.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "getAllProfiles",
    },
  }).then((result) => result.json());
};

const checkScanMiners = (farmUrl: string, farmKey: string) => async () => {
  if (farmUrl !== "" && farmUrl !== null && farmKey !== "") {
    return await fetch(`${farmUrl}/miners.php`, {
      method: "POST",
      mode: "cors",
      headers: {
        token: farmKey,
        action: "checkScan",
      },
    })
      .then((result) => result.json())
      .then(({ message }) => message)
      .catch(() => {});
  } else {
    return "loading";
  }
};

export const useCheckScan = (
  farmUrl: string,
  farmKey: string,
  refetchInterval?: number
) => {
  return useQuery(["checkScan", sessionStorage.getItem("farm_name")], checkScanMiners(farmUrl, farmKey), {
    refetchInterval,
  });
};

const checkDecision = (farmUrl: string, farmKey: string) => async () => {
  if (farmUrl !== "" && farmUrl !== null && farmUrl !== null && farmKey !== "") {
    return await fetch(`${farmUrl}/action.php`, {
      method: "POST",
      mode: "cors",
      headers: {
        token: farmKey,
        action: "getDecisionProcess",
      },
    })
      .then((result) => result.json())
      .then(({ decision_process }) => decision_process)
      .catch(() => {});
  } else {
    return "loading";
  }
};

export const useCheckDecision = (
  farmUrl: string,
  farmKey: string,
  refetchInterval?: number
) => {
  return useQuery(["checkDecision", sessionStorage.getItem("farm_name")], checkDecision(farmUrl, farmKey), {
    refetchInterval,
  });
};

export const ScanMiners = (farmUrl: string, farmKey: string, ip: string) => {
  const body = new FormData();
  if (farmUrl === "http://localhost:8000") {
    body.set("useMock", "yes");
    body.set("mockUrl", "http://192.168.8.101:8000");
    body.set("mockSleep", "500000");
  }
  body.set("action", "importMiners");
  body.set("ipRange", ip);

  return fetch(`${farmUrl}/miners.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "importMiners",
    },
    body,
  })
    .then((result) => result.text())
    .catch(() => {});
};

export const UpdateMiner = (farmUrl: string, farmKey: string, ip: string, decision: string, value: string) => {
  return fetch(`${farmUrl}/profiles.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "setProfileDecision",
      ip,
    },
    body: `{"${decision}": "${value}"}`,
  })
    .then((result) => result.text())
    .catch(() => {});
};

export const DeleteMiner = (farmUrl: string, farmKey: string, ip: string) => {
  const body = new FormData();
  body.set("ip", ip);

  return fetch(`${farmUrl}/profiles.php`, {
    method: "POST",
    mode: "cors",
    headers: {
      token: farmKey,
      action: "deleteProfile",
    },
    body,
  })
    .then((result) => result.text())
    .catch(() => {});
};
